<template>
  <div id="app">
    <ul class="bg">
      <li><span></span></li>
    </ul>
    <div id="skip">
      <a href="#main">Skip Navigation Links</a>
    </div>

    <navigation />
    <ftu />

    <router-view />

    <the-foot />
  </div>
</template>

<script>
import $ from 'jquery'

import navigation from '@/components/navigation'
import ftu from '@/components/ftu'
import theFoot from '@/components/footer'

export default {
  name: 'App',
  components: {
    navigation,
    ftu,
    theFoot
  },
  data () {
    return {
      backgroundPic: ''
    }
  },

  methods: {
    dispBG: function () {
      var images = [
        'background1.jpg'
      ]
      $('body').css({ background: 'url(https://www.csub.edu/selfservice/images/' + images[Math.floor(Math.random() * images.length)] + ') no-repeat center fixed', 'background-size': 'cover' })
    }
  },
  mounted () {
    // Display Background Picture
    this.dispBG()

    // Shows up-arrow for past events
    $(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $('#back-top').fadeIn()
        } else {
          $('#back-top').fadeOut()
        }
      })

      // scroll body to 0px on click
      $('#back-top a').click(function () {
        $('body,html').animate({
          scrollTop: 0
        }, 800)
        return false
      })
    })
  }
}
</script>

<style>
  /* ====================================================+
  |   GLOBAL STYLES with Google Fonts                    |
  +===================+=================================*/
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&family=Oswald&display=swap');
  html {
    height: 100%;
    min-height: 100%;
  }

  #bodyInit {
    /*background: url('/selfservice/images/myCSUB_background1.jpg') no-repeat center fixed;
    background: url('myhr-background.jpg') no-repeat center fixed;*/
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    background-size: cover;
    margin-bottom: 60px;
    min-height: 70%;
    padding-bottom: 60px;
  }

  .bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 0;
    content: '';
    background: transparent url(./assets/images/pattern.png) repeat top left;
  }

  .bg li {
    list-style: none;
  }

  #pswrapper hr {
    border-top: 1px solid #ddd;
  }

  .pastAnnounce {
    cursor: pointer;
  }

  .ftu {
    cursor: pointer;
  }

  /* ====================================================+
  |   SKIP NAVIGATION                                    |
  +===================+=================================*/
  #skip a, #skip a:hover, #skip a:visited {
    position: absolute;
    left: 0px;
    top: -500px;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  #skip a:active, #skip a:focus {
    position: static;
    width: auto;
    height: auto;
  }

/* ====================================================+
|   HIDDEN OBJECTS                                     |
+===================+=================================*/
  #ptLabelSelect, #ps_select_parent, .hideSub, #accessible, #accessible + label, #ptfooter, .ps-link, .ps-staticimg, #error_link, #orgFooterImg, #orgLoginLk, .ps_box-info{
    display: none;
  }

  #firstTimeUserPopUp {
    position: absolute;
    margin: auto;
    max-width: 500px;
    min-width: 300px;
    width: 70%;
    z-index: 20;
    top: 12%;
    left: 10%;
  }

  #firstTimeUserPopUp .firstTimeImg {
    border-radius: 8px;
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
  }

  /* ====================================================+
  |   FORM CONTAINER STYLES                              |
  +===================+=================================*/
  #main {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    width: 95%;
    max-width: 950px;
    margin-top: 120px;
    margin-bottom: 40px;
    padding: 0px 30px 30px 0px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    opacity: 0.98;
  }

  .mainHeader {
    padding-left: 30px !important;
    padding-top: 15px !important;
    color: #003595 !important;
    font-size: 28px !important;
    text-shadow: 1.25px 1.25px 0px #e1bc0e, 2px 2px 0px #e1bc0e;
    font-weight: bold;
  }

  #mainExpire {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    width: 85%;
    max-width: 950px;
    margin-top: 150px !important;
    padding: 0px 30px 30px 0px;
    /*padding: 0px 0px 30px 0px;*/
    /*margin-bottom: 50px;*/
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    opacity: 0.98;
    text-align: center;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif;
  }

  #mainExpire h3 {
    font-family: 'Open Sans', sans-serif;
    font-weight: bold;
    color: #003595 !important;
    font-size: 28px !important;
    text-shadow: 1.25px 1.25px 0px #e1bc0e, 2px 2px 0px #e1bc0e;
    font-weight: bold;
    padding-bottom: 10px;
  }

  #mainExpire p {
    line-height: 200%;
    padding-left: 15%;
    padding-right: 15%;
  }

  #frm-title {
    text-align: center;
  }

  #frm-title h2 {
    font-size: 18px;
    font-size: 2vh;
  }

  /* ====================================================+
  |   SIGNIN CONTAINER STYLES                            |
  +===================+=================================*/
  #pswrapper {
    background-color: transparent;
    padding-left: 36px;
    padding-bottom: 0px;
    padding-top: 5px;
    padding-right: 20px;
    width: 98%;
    font-size: 16px;
    font-family: 'Open Sans', sans-serif;
    text-align: center;
  }

  #userid, #pwd {
    margin-bottom: 10px;
    font-size: 14px;
    font-family: 'Driod+Sans', sans-serif;
    color: #003595 !important;
  }

  .ps_box_button {
    padding-top: 5px;
  }

  #login_error {
    color: red !important;
    font-weight: bold;
    background: rgba(255, 210, 0, 0.75);
    text-align: center;
    animation: login_error 0.5s 1;
    -webkit-animation: login_error 0.5s 1;
    animation-fill-mode: forwards;
    animation-delay: 10s;
    -webkit-animation-delay: 10s; /* Safari and Chrome */
    -webkit-animation-fill-mode: forwards;
  }

  @keyframes login_error {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      overflow: hidden;
    }
  }

  @-webkit-keyframes login_error {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      visibility: hidden;
    }
  }

  .maint {
    padding-left: 36px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #f00;
    font-size: 12px;
    width: 98%;
  }

  #firstTimeUser {
    float: right;
    padding-left: 4px;
  }

  #firstTimeUser:hover {
    color: #b12323;
    text-decoration: none;
  }

  /* ====================================================+
  |   INFO CONTAINER STYLES                              |
  +===================+=================================*/
  #info {
    font-size: 12px;
    font-family: "Open Sans", "sans-serif";
  }

  .form-box h3 {
    font-size: 20px;
    font-family: 'Open Sans', sans-serif;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }

  #info h4 {
    background: #0072bc;
    color: #fff;
    padding: 3px;
    font-size: 16px;
  }

  #info ul.icon {
    list-style-type: none;
    padding: 0;
    margin-left: 20px;
    padding: 0px 10px 10px 10px;
  }

  #info ul.icon li {
    border-bottom: 1px solid #ccc;
    padding: 10px 10px 10px 10px;
  }

  #info ul.icon li:last-child {
    border: none;
  }

  #info ul.icon li > a {
    text-decoration: none;
    font-size: 12px;
    color: #003595;
    font-weight: bold;
  }

  #info ul.icon li > a:hover {
    text-decoration: none;
    color: #003595;
    font-weight: bold;
  }

  #info ul.icon li:hover {
    text-decoration: none;
    color: #003595;
    background-color: rgba(255, 210, 0, 0.35);
  }

  /* ====================================================+
  |   RETURN TO TOP STYLES                            |
  +===================+=================================*/
  #back-top {
    position: fixed;
    bottom: 130px;
    margin-left: 750px;
  }

  #back-top a {
    width: 50px;
    display: block;
    text-align: center;
    font: 11px/100% Arial, Helvetica, sans-serif;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: bold;
    color: rgba(79, 179, 207, 0.76);
    /* transition */
    -webkit-transition: 1s;
    -moz-transition: 1s;
    transition: 1s;
  }

  #back-top a:hover {
    color: #0b6dac;
    font-weight: bold;
  }

  /* arrow icon (span tag) */
  #back-top span {
    width: 50px;
    height: 50px;
    display: block;
    margin-bottom: 10px;
    background: rgba(79, 179, 207, 0.76) url('./assets/images/myCSUB_up_arrow.png') no-repeat center center;
    background-size: 40px 40px;
    /* rounded corners */
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    /* transition */
    -webkit-transition: 1s;
    -moz-transition: 1s;
    transition: 1s;
  }

  #back-top a:hover span {
    background-color: #0b6dac;
  }
</style>
